import UserDetails from '../components/form/update-profile-form/user-details';
import { useSetPageTitle } from "../hooks/useSetPageTitle";
import { DashboardMenubar } from 'src/components/menubar/menubar';

const AccountSettingsScreen = () => {
  useSetPageTitle('Account Settings');

  return (
    <div className='min-h-screen w-full bg-[#F6F6F6]'>
      <DashboardMenubar
        bgColorClass=""
        showHomeButton={true}
      />
      <div className="flex justify-center p-6 sm-max:px-0">
        <div className="w-full max-w-3xl">
          <UserDetails />
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsScreen;
